import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ExperimentCreatePage = lazy(
  () => import('~/features/catalog-v2/pages/experiment-create-page'),
);

/** `draft` resumes the wizard on an existing DRAFT experiment at its saved stage. */
const experimentCreateSearchSchema = z.object({
  draft: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/experiments/new')({
  validateSearch: experimentCreateSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ExperimentCreatePage />
    </Suspense>
  ),
});
